//#region style
import React from "react";

export const buttonPrimaryStyle = {
    backgroundColor: '#2C5A73' as const,
    borderRadius: '10px' as const,
    color: '#ffffff' as const,
};
export const buttonDangerStyle = {
    backgroundColor: '#EB696A' as const,
    borderRadius: '10px' as const,
    color: '#ffffff' as const,
};
export const buttonSizeStyle = {
    fontSize: '16px',
    padding: '10px 20px',
};
export const toggleDropdownItemStyle = {
    padding: '8px 16px', // Customize padding as needed
    color: '#333', // Customize text color
    backgroundColor: '#f8f9fa', // Customize background color
    cursor: 'pointer', // Add a pointer cursor for better usability
};
export const btnStyle = {
    width: "100%",
    minHeight: "100px",
    fontWeight: "bold",
};
export const listStyle = {
    listStyle: "none",
    borderRadius: "5px",
    backgroundColor: "#f9f9f9",
    border: "1px solid #ccc",
    padding: "0px",
    height: "80vh",
    overflow: "auto",
};
export const beneficiaryListStyle = {
    listStyle: "none",
    borderRadius: "5px",
    backgroundColor: "#f9f9f9",
    border: "1px solid #ccc",
    padding: "0px",
    width: "100%", // Set width to 80% of the parent container
    height: "80%", // Set height to 80% of the parent container
    maxHeight: "80vh", // Set a maximum height if needed
    overflow: "auto",
};
export const listItemStyle = {
    padding: "10px 0px",
    marginBottom: "10px",
    backgroundColor: "#f1f1f1",
    cursor: "pointer",
};
export const active = {
    padding: "10px 0px",
    marginBottom: "10px",
    backgroundColor: "#999",
    cursor: "pointer",
    color: "#fff",
};
export const smallBtnStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minWidth: "25px",
    height: "31px",
    borderRadius: "50%",
    fontWeight: "bold",
};
export const beneficiarySearchBtnStyle={
    backgroundColor: "#2c5a73",
    color: "#ffffff",
    border: "none",
    padding: "12px 20px",
    borderRadius: "8px",
    fontWeight: "450",
    minWidth: "100px",
    fontSize: "15px",
}
export const beneficiaryCancelSearchBtnStyle={
    backgroundColor: "#dcdde1",
    color: "black",
    border: "none",
    padding: "12px 20px",
    borderRadius: "8px",
    fontWeight: "450",
    minWidth: "100px",
    fontSize: "15px",
}
export const beneficiaryCloseSearchModelBtnStyle={
    backgroundColor: "#d84d37",
    color: "#ffffff",
    border: "none",
    padding: "12px 20px",
    borderRadius: "8px",
    fontWeight: "450",
    minWidth: "100px",
    fontSize: "15px",
}
export const  beneficiarySearchTextBoxStyle={
    border: "1.5px solid #5b7581",
    borderRadius: "5px",
    padding: "8px 12px",
    color: "#4c4c4c",
    width: "100%",
    maxWidth: "350px",
    outline: "none",
}
export const beneficiaryInfoButtonStyle = {
        backgroundColor: "#ecf4f7",
        border: "1px soild #adc6d6",
        borderRadius: "6px",
        //width: buttonWidth,
        textAlign: "center" as const,
        padding: "14px 18px",
        fontSize: window.innerWidth < 600 ? "14px" : "16px",
        color: "#2c5873",
        marginTop: "8px",
        overflow: "hidden",
        wordBreak: "break-word"
}as React.CSSProperties

export const customCategoryItemStyle: React.CSSProperties = {
    padding: "7px 20px",
    borderRadius: "7px",
    backgroundColor: "#eef7ff",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    border: "1px solid #c8c7c7",
};

export const customCategoryItemHoverStyle: React.CSSProperties = {
    backgroundColor: "#eae7e7",
};

export const customCategoryItemActiveStyle: React.CSSProperties = {
    backgroundColor: "rgb(44, 90, 115)",
    color: "white",
    fontWeight: "bold",
};

export const customCategoryListStyle: React.CSSProperties = {
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    flexDirection: "column",
    gap: "7px",
    height: "466px",
};
export const cardsDisplayStyle: React.CSSProperties = {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)", // 4 columns
    gridTemplateRows: "repeat(4, auto)",  // 4 rows
    gap: "8px",
    padding: "14px",
    backgroundColor: "white",
    borderRadius: "8px",
    border: "1px solid #eee",
    maxHeight: "70vh",
    overflowY: "auto",
};

export const cardDisplayStyle: React.CSSProperties = {
    backgroundColor: "inherit",
    height: "90px",
    borderRadius: "6px",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
    overflow: "auto",
    border: "2px solid #61dafb",
    fontWeight: 600,
    cursor: "pointer",
};
export const cardBtnClickStyle: React.CSSProperties = {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    backgroundColor: "transparent",
    fontSize: "15px",
    wordBreak: "break-word",
    padding: "6px",
    cursor: "pointer",
    transition: "background-color 0.2s ease",
};

export const cardBtnClickActiveStyle: React.CSSProperties = {
    backgroundColor: "#e6f7ff",
    color: "#333",
    fontWeight: 700,
};

export const cardDisplayHoverStyle: React.CSSProperties = {
    backgroundColor: "#e6f7ff",
};
export const tableCellHeaderStyle: React.CSSProperties = {
    background: 'rgba(51, 124, 153, 0.81)',
    color: 'white',
    minWidth: '40px',
};

export const quantityInputStyle = {
    width: '54px',
    textAlign: 'center' as const,
    border: '1px solid #ccc',
    borderRadius: '4px',
    padding: '3px',
};

export const popupQuantityInputBoxStyle = {
    position: 'absolute' as const,
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    padding: '10px',
    display: 'flex',
    flexWrap: 'wrap' as const,
    gap: '5px',
    zIndex: 999,
};

export const quantityValueBoxStyle = {
    marginBottom: '8px',
    width: '100%',
    textAlign: 'center' as const,
    padding: '5px',
    border: '1px solid #337c99',
};

export const popupNumberButtonStyle: React.CSSProperties = {
    width: '40px',
    height: '40px',
    fontSize: '16px',
};

export const popupDeleteButtonStyle: React.CSSProperties = {
    width: '85px',
    height: '40px',
    fontSize: '16px',
    backgroundColor: '#f44336',
    color: '#fff',
};

export const popupActionButtonStyle: React.CSSProperties = {
    width: '48%',
    padding: '8px',
    border: 'none',
    borderRadius: '4px',
};

export const popupCancelButtonStyle: React.CSSProperties = {
    ...popupActionButtonStyle,
    backgroundColor: '#f44336',
    color: '#fff',
};

export const popupConfirmButtonStyle: React.CSSProperties = {
    ...popupActionButtonStyle,
    backgroundColor: '#337c99',
    color: '#fff',
};
export const tableHeadEmptyStyle: React.CSSProperties = {
    backgroundColor: 'rgba(51, 124, 153, 0.81)',
    minWidth: '40px',
    color: 'white',
};

export const tableHeadColoredStyle: React.CSSProperties = {
    backgroundColor: 'rgba(51, 124, 153, 0.81)',
    color: 'white',
    minWidth: '40px',
    fontWeight: 'bold',
    textAlign: 'center',
};
export const iconBtnStyle: React.CSSProperties = {
    border: "none",
    backgroundColor: "transparent",
    cursor: "pointer",
    padding: "4px",
};

export const tableItemCellStyle: React.CSSProperties = {
    textAlign: "start",
    paddingLeft: "8px",
};

export const quantityCellStyle: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
};

export const qtyBtnStyle: React.CSSProperties = {
    width: "30px",
    height: "30px",
    fontSize: "16px",
    fontWeight: "bold",
    border: "1px solid #ccc",
    borderRadius: "4px",
    backgroundColor: "#f0f0f0",
    cursor: "pointer",
};

export const qtyInputStyle: React.CSSProperties = {
    width: "50px",
    textAlign: "center",
    border: "1px solid #ccc",
    borderRadius: "4px",
    padding: "4px",
};

export const accordionRowStyle: React.CSSProperties = {
    backgroundColor: "#f8f9fa",
    padding: "10px",
};

export const accordionLabelStyle: React.CSSProperties = {
    marginBottom: "5px",
    fontSize: "0.9rem",
    color: "#333",
    display: "flex",
    justifyContent: "space-between",
};
export const popupRowStyle: React.CSSProperties = {
    backgroundColor: "#ffffff",
    padding: "10px",
};

export const popupContainerStyle: React.CSSProperties = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px 0",
};

export const popupBoxStyle: React.CSSProperties = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "8px",
    padding: "12px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    backgroundColor: "#fff",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
};

export const popupInputValueStyle: React.CSSProperties = {
    width: "100%",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "18px",
    marginBottom: "10px",
};

export const popupBtnStyle: React.CSSProperties = {
    width: "48px",
    height: "48px",
    fontSize: "16px",
    fontWeight: "bold",
    borderRadius: "4px",
    border: "1px solid #ccc",
    backgroundColor: "#f5f5f5",
    cursor: "pointer",
};

export const popupDelBtnStyle: React.CSSProperties = {
    width: "100px",
    height: "40px",
    fontSize: "14px",
    backgroundColor: "#dc3545",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    marginTop: "10px",
    cursor: "pointer",
};
export const popupActionsStyle: React.CSSProperties = {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    marginTop: "10px",
    gap: "10px",
};

export const popupCancelBtnStyle: React.CSSProperties = {
    flex: 1,
    backgroundColor: "#f44336",
    color: "#fff",
    border: "none",
    padding: "10px",
    borderRadius: "5px",
    cursor: "pointer",
    fontWeight: "bold",
};

export const popupOkBtnStyle: React.CSSProperties = {
    flex: 1,
    backgroundColor: "#2c5a73",
    color: "#fff",
    border: "none",
    padding: "10px",
    borderRadius: "5px",
    cursor: "pointer",
    fontWeight: "bold",
};

export const labelBoxLabelStyle: React.CSSProperties = {
    color: "rgb(44, 90, 115)",
    fontSize: "18px",
    fontWeight: "550",
    fontFamily: '"Bebas Neue", sans-serif',
    letterSpacing: "1.6px",
};

export const labelBoxValueStyle: React.CSSProperties = {
    backgroundColor: "#eef7ff",
    color: "#003366",
};

export const cardsContainerPosStyle: React.CSSProperties = {
    backgroundColor: "white",
    width: "100%",
    height: "85vh",
    margin: "10px 0",
    borderRadius: "6px",
    border: "1px solid azure",
    overflowY: "auto",
    overflowX: "hidden",
    display: "flex",
    flexDirection: "column",
};

export const cardsGroupPosStyle: React.CSSProperties = {
    display: "flex",
    flexWrap: "wrap",
    padding: "10px",
};

export const cardPosStyle: React.CSSProperties = {
    flex: "1 1 180px",
    minHeight: "200px",
    maxHeight: "100%",
    borderRadius: "4px",
    overflow: "auto",
    padding: "4px",
};

export const cardDetailsContainerStyle: React.CSSProperties = {
    maxHeight: "80vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: "25px",
};

export const cardInfoStyle: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    gap: "14px",
};

//#endregion
// #saveAndPayButton,#newButton, #billOptionsActionDropdown, #beneficiaryActionDropdown,#selectItemButton,#selectEmployeeButton,#printButton{
//     background-color:#2C5A73 !important;
//     border-radius: 10px;
//     color: #ffffff;
// }